'use client';

import { useTranslations } from 'next-intl';
import { FlagValue, MediaValue, ProductVisualMobile } from '@headless-workspace/domain/common/client';
import { Component, Image } from '@headless-workspace/typings';
import { ProductVisualDesktop } from './ProductVisualDesktop';

export type ProductDetailVisualProps = {
    medias: MediaValue[];
    flags?: FlagValue[];
    onProductDetailVisualClick: (index: number) => void;
    socialProof?: string;
    highlightedImage?: Image;
};

export const ProductDetailVisual: Component<ProductDetailVisualProps> = ({
    medias,
    flags,
    onProductDetailVisualClick,
    socialProof,
    highlightedImage,
}) => {
    const t = useTranslations('Discover.Pdp');

    const sharedProps = {
        medias,
        flags,
        socialProof,
        onProductVisualClick: onProductDetailVisualClick,
        highlightedImage,
    };

    return (
        <>
            <ProductVisualMobile
                {...sharedProps}
                wrapperClassName={'w-productVisualCarousel tablet:w-productVisualCarouselTablet'}
                containerClassName={'desktopS:hidden'}
                visualClassName={'w-productVisual tablet:w-productVisualTablet'}
                prevBtnAriaLabel={t('carousel.ariaLabel.prevBtn')}
                nextBtnAriaLabel={t('carousel.ariaLabel.nextBtn')}
                thumbArialLabel={t('carousel.ariaLabel.thumb')}
            />
            <ProductVisualDesktop {...sharedProps} className={'hidden desktopS:block desktopS:pl-1.5 desktop:pl-0'} />
        </>
    );
};
